import { Directive, ElementRef, HostListener } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';

@Directive({
    selector: '[cbEllipsis]',
    providers: [MatTooltip],
    standalone: false
})
export class EllipsisDirective {

    private elementNode: HTMLElement;

    constructor(
        private elementRef: ElementRef,
        private tooltip: MatTooltip
    ) {
        this.elementNode = this.elementRef.nativeElement;
    }

    @HostListener('mouseover')
    public onHover(): void {
        if (this.elementNode.offsetWidth < this.elementNode.scrollWidth) {
            this.tooltip.tooltipClass = 'cb-dark-gray-bg';
            this.tooltip.message = this.elementNode.innerHTML;
            this.tooltip.show();
        }
    }

    @HostListener('mouseout')
    public hide(): void {
        this.tooltip.hide();
    }


}
